import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { Machine, MaintenanceTask } from '../../core/models';

@Component({
  selector: 'app-tasks',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './tasks.component.html',
  styleUrl: './tasks.component.scss',
})
export class TasksComponent implements OnInit {
  private api = inject(ApiService);
  tasks = signal<MaintenanceTask[]>([]);
  machines = signal<Machine[]>([]);
  filterStatus = '';
  showForm = signal(false);
  form = {
    machine_id: '',
    title: '',
    due_at: '',
    scheduled_at: '',
    notes: '',
  };

  ngOnInit(): void {
    this.api.get<Machine[]>('/api/machines').subscribe((m) => {
      this.machines.set(m);
      if (m.length && !this.form.machine_id) {
        this.form.machine_id = m[0].id;
      }
    });
    this.reload();
  }

  reload(): void {
    const params: Record<string, string | boolean> = { include_done: true };
    if (this.filterStatus) {
      params['status'] = this.filterStatus;
    }
    this.api.get<MaintenanceTask[]>('/api/tasks', params).subscribe((t) => this.tasks.set(t));
  }

  create(): void {
    const body = {
      machine_id: this.form.machine_id,
      title: this.form.title,
      notes: this.form.notes || null,
      due_at: this.form.due_at ? new Date(this.form.due_at).toISOString() : null,
      scheduled_at: this.form.scheduled_at
        ? new Date(this.form.scheduled_at).toISOString()
        : null,
    };
    this.api.post<MaintenanceTask>('/api/tasks', body).subscribe(() => {
      this.showForm.set(false);
      this.form.title = '';
      this.form.notes = '';
      this.reload();
    });
  }
}
